// extracted by mini-css-extract-plugin
module.exports = {"title":"job-teasers-grid-module--title--3sOh8","teasersContainer":"job-teasers-grid-module--teasersContainer--Grl_Y","jobTeaser":"job-teasers-grid-module--jobTeaser--3UW8f"};